import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface UserIdSfResult {
  retrieveUserIdSf: () => string | undefined
  saveUserIdSf: (userName: string | undefined) => void
  removeUserIdSf: () => void
}

export const useUserIdSf: () => UserIdSfResult = () => {
  const { getUserIdSf, setUserIdSfInStore, removeUserIdSfFromStore } = useContext(AppStateContext)

  const retrieveUserIdSf = useCallback(() => getUserIdSf(), [getUserIdSf])
  const saveUserIdSf = useCallback((userIdSf: string | undefined) => setUserIdSfInStore(userIdSf), [setUserIdSfInStore])
  const removeUserIdSf = useCallback(() => removeUserIdSfFromStore(), [removeUserIdSfFromStore])

  return {
    retrieveUserIdSf,
    saveUserIdSf,
    removeUserIdSf,
  }
}
